import axios from 'axios'

export default {
  namespaced: true,

  state: {
    adspotSupplierList: {
      /**
       * structure as below:
       * adspotId: {
       *   supplierList: [],
       *   total: 0,
       *   current: undefined,
       *   editId: undefined,
       *   editAdspotSupplier: null
       * }
       */
    }
  },

  getters: {
    supplierList: ({ adspotSupplierList }) => (id) => adspotSupplierList[id] && adspotSupplierList[id].supplierList,
    total: ({ adspotSupplierList }) => (id) => adspotSupplierList[id] && adspotSupplierList[id].total,
    current: ({ adspotSupplierList }) => (id) => adspotSupplierList[id] && adspotSupplierList[id].current,
    editId: ({ adspotSupplierList }) => (id) => adspotSupplierList[id] && adspotSupplierList[id].editId,
    editAdspotSupplier: ({ adspotSupplierList }) => (id) => adspotSupplierList[id] &&
      adspotSupplierList[id].editAdspotSupplier
  },

  mutations: {
    init (state, { adspotId }) {
      if (!state.adspotSupplierList[adspotId]) {
        state.adspotSupplierList[adspotId] = {
          supplierList: [],
          total: 0,
          current: undefined,
          editId: undefined,
          editAdspotSupplier: null
        }
        state.adspotSupplierList = { ...state.adspotSupplierList }
      }
    },

    add (state, { adspotId }) {
      if (!state.adspotSupplierList[adspotId].supplierList[0] ||
        state.adspotSupplierList[adspotId].supplierList[0].id
      ) {
        state.adspotSupplierList[adspotId].editId = undefined
        state.adspotSupplierList[adspotId].editAdspotSupplier = {
          adspot_id: adspotId,
          supplier_adspot_id: '',
          priority: 1,
          percentage: 100,
          time_out: 1000,
          ip_white_list: [],
          after_direct: [],
          after_direct2: [],
          location_list: [],
          status: 1
        }
        state.adspotSupplierList[adspotId].supplierList.unshift({})
      }
      state.adspotSupplierList[adspotId] = { ...state.adspotSupplierList[adspotId] }
      state.adspotSupplierList = { ...state.adspotSupplierList }
    },

    cancelAdd (state, { adspotId }) {
      state.adspotSupplierList[adspotId].editAdspotSupplier = null
      state.adspotSupplierList[adspotId].supplierList.shift()
      state.adspotSupplierList = { ...state.adspotSupplierList }
    },

    edit (state, { adspotId, adspotSupplier }) {
      state.adspotSupplierList[adspotId].editId = adspotSupplier.id
      let newAdspotSupplier = { ...adspotSupplier }
      delete newAdspotSupplier._index
      delete newAdspotSupplier._rowKey
      state.adspotSupplierList[adspotId].editAdspotSupplier = newAdspotSupplier
      if (state.adspotSupplierList[adspotId].supplierList[0] &&
        !state.adspotSupplierList[adspotId].supplierList[0].id
      ) {
        state.adspotSupplierList[adspotId].supplierList.shift()
      }
      state.adspotSupplierList = { ...state.adspotSupplierList }
    },

    cancelEdit (state, { adspotId }) {
      state.adspotSupplierList[adspotId].editId = undefined
      state.adspotSupplierList[adspotId].editAdspotSupplier = null
      state.adspotSupplierList = { ...state.adspotSupplierList }
    },

    replace (state, { adspotId, adspotSupplier }) {
      const index = state.adspotSupplierList[adspotId].supplierList
        .findIndex(item => !item.id || item.id === adspotSupplier.id)
      state.adspotSupplierList[adspotId].supplierList.splice(index, 1, adspotSupplier)
      state.adspotSupplierList = { ...state.adspotSupplierList }
    },

    setList (state, { adspotId, supplierList, total, current }) {
      supplierList.forEach(item => {
        if (item.include_episode_type_list) {
          item.includeEpisodeType = 'type'
        }
        if (item.include_episode_id_list) {
          item.includeEpisodeType = 'season'
        }
        if (item.include_current_episode_list) {
          item.includeEpisodeType = 'episode'
        }

        if (item.exclude_episode_type_list) {
          item.excludeEpisodeType = 'type'
        }
        if (item.exclude_episode_id_list) {
          item.excludeEpisodeType = 'season'
        }
        if (item.exclude_current_episode_list) {
          item.excludeEpisodeType = 'episode'
        }

        if (!item.app_versions) {
          item.appVersionType = 'include'
        } else {
          switch (item.app_versions[0]) {
            case '>':
              item.appVersionType = 'greater'
              item.app_versions = item.app_versions.substring(2)
              break
            case '<':
              item.appVersionType = 'smaller'
              item.app_versions = item.app_versions.substring(2)
              break
            case '!':
              item.appVersionType = 'exclude'
              item.app_versions = item.app_versions.substring(1)
              break
            default:
              item.appVersionType = 'include'
          }
        }
      })
      state.adspotSupplierList[adspotId].supplierList = [...supplierList]
      state.adspotSupplierList[adspotId].total = total
      state.adspotSupplierList[adspotId].current = current
      state.adspotSupplierList = { ...state.adspotSupplierList }
    },

    remove (state, { adspotId, supplierId }) {
      const index = state.adspotSupplierList[adspotId].supplierList.findIndex(item => item.id === supplierId)
      state.adspotSupplierList[adspotId].supplierList.splice(index, 1)
      state.adspotSupplierList = { ...state.adspotSupplierList }
    },

    changeIncludeEpisodeType (state, { adspotId, type }) {
      state.adspotSupplierList[adspotId].editAdspotSupplier.include_episode_type_list = ''
      state.adspotSupplierList[adspotId].editAdspotSupplier.include_episode_id_list = ''
      state.adspotSupplierList[adspotId].editAdspotSupplier.include_current_episode_list = ''
      state.adspotSupplierList[adspotId].editAdspotSupplier.includeEpisodeType = type
      state.adspotSupplierList = { ...state.adspotSupplierList }
    },

    changeExcludeEpisodeType (state, { adspotId, type }) {
      state.adspotSupplierList[adspotId].editAdspotSupplier.exclude_episode_type_list = ''
      state.adspotSupplierList[adspotId].editAdspotSupplier.exclude_episode_id_list = ''
      state.adspotSupplierList[adspotId].editAdspotSupplier.exclude_current_episode_list = ''
      state.adspotSupplierList[adspotId].editAdspotSupplier.excludeEpisodeType = type
      state.adspotSupplierList = { ...state.adspotSupplierList }
    },

    changeAppVersionType (state, { adspotId, type }) {
      var appVersions = state.adspotSupplierList[adspotId].editAdspotSupplier.app_versions || ''
      if (['greater', 'smaller'].indexOf(type) !== -1) {
        appVersions = appVersions.split(',')[0]
      }
      state.adspotSupplierList[adspotId].editAdspotSupplier.app_versions = appVersions
      state.adspotSupplierList[adspotId].editAdspotSupplier.appVersionType = type
      state.adspotSupplierList = { ...state.adspotSupplierList }
    },

    formatData (state, { adspotId }) {
      var editAdspotSupplier = state.adspotSupplierList[adspotId].editAdspotSupplier
      var format = (path) => {
        if (editAdspotSupplier[path]) {
          editAdspotSupplier[path] = editAdspotSupplier[path]
            .replace(/[：；，:;,]/g, ',')
            .replace(/[^\w,]/g, '')
            .split(',')
            .filter(item => item)
            .join(',')
        }
      }
      format('include_episode_type_list')
      format('include_episode_id_list')
      format('include_current_episode_list')
      format('exclude_episode_type_list')
      format('exclude_episode_id_list')
      format('exclude_current_episode_list')

      var appVersions, appVersionType
      if ((appVersions = editAdspotSupplier.app_versions) && (appVersionType = editAdspotSupplier.appVersionType)) {
        var operatorMap = {
          greater: '>=',
          smaller: '<=',
          include: '',
          exclude: '!'
        }
        var prefix = operatorMap[appVersionType]

        if (['greater', 'smaller'].indexOf(appVersionType) !== -1) {
          appVersions = appVersions.split(',')[0]
        } else {
          appVersions = appVersions.replace(/[：；，:;,]/g, ',')
            .split(',')
            .filter(item => item)
            .map(item => item.trim())
            .join(',')
        }
        editAdspotSupplier.app_versions = prefix + appVersions
      }
    }
  },

  actions: {
    getAll ({ commit }, { adspotId }) {
      return axios.get(`/adspot-supplier-setting/?adspotId=${adspotId}`).then(result => {
        commit('setList', {
          adspotId,
          supplierList: [...result.data],
          total: result.data.length,
          current: 1
        })
      })
    },

    submitAdd ({ getters, commit, dispatch }, { adspotId }) {
      commit('formatData', { adspotId })
      axios.post(`/adspot-supplier-setting/?adspotId=${adspotId}`, {
        adspot_supplier_setting: getters.editAdspotSupplier(adspotId)
      }).then(result => {
        if (result !== -1) {
          commit('replace', { adspotId, adspotSupplier: result.data })
          this._vm.$Message.success('添加渠道设置成功')
          commit('cancelEdit', { adspotId })
          dispatch('getAll', { adspotId })
        }
      })
    },

    submitEdit ({ getters, commit, dispatch }, { adspotId }) {
      commit('formatData', { adspotId })
      axios.put(`/adspot-supplier-setting/${getters.editAdspotSupplier(adspotId).id}`, {
        adspot_supplier_setting: getters.editAdspotSupplier(adspotId)
      }).then(result => {
        if (result !== -1) {
          commit('replace', { adspotId, adspotSupplier: result.data })
          this._vm.$Message.success('更新渠道设置成功')
          commit('cancelEdit', { adspotId })
          dispatch('getAll', { adspotId })
        }
      })
    },

    delete ({ commit, dispatch }, { adspotId, supplierId }) {
      axios.delete(`/adspot-supplier-setting/${supplierId}`).then(result => {
        commit('remove', { adspotId, supplierId })
        this._vm.$Message.success(result.data)
        commit('cancelEdit', { adspotId })
        dispatch('getAll', { adspotId })
      })
    }
  }
}
